export default "__VITE_ASSET__c43b1afe__"